import { TextInputField } from '@sainsburys-tech/luna-form'
import { OutlinedButton } from '@sainsburys-tech/luna-button'
import { ScanButton } from '@jsainsburyplc/retail-search-scanner'

interface IProductLookupInput {
  lookupField: string
  productNotFoundError: string
  onLookupChange: (e: any) => void
  onSearchClick: () => void
  onScan: (code: any) => void
  onScanError: (msg: any) => void
}

function ProductLookupInput({
  lookupField,
  productNotFoundError,
  onLookupChange,
  onSearchClick,
  onScan,
  onScanError
}: IProductLookupInput) {
  return (
    <>
      <ScanButton
        onScan={onScan}
        onInvalid={onScanError}
      />
      <TextInputField
        className="ln-u-margin-top*2"
        name={'product-lookup-input'}
        label={'Enter a product name, SKU or EAN'}
        onChange={onLookupChange}
        value={lookupField}
        error={productNotFoundError}
        placeholder={'Enter a product name, SKU or EAN ...'}
      />
      <OutlinedButton
        className="ln-u-margin-bottom*2"
        fullWidth
        onClick={onSearchClick}
      >
        {'Search product'}
      </OutlinedButton>
    </>
  )
}

export default ProductLookupInput
